module.exports = "https://cdn-assessment.mathletics.com/app/108/assets/images/1232bb6d97fa8c16f3c7257418860782.svg";